/**
 * Profile Page Component
 */
import { User } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { ResponsiveLayout } from "../../components/layout";

const ProfilePage = () => {
  const { user } = useAuth();

  const getRoleLabel = (role) => {
    const roles = { agent: 'Agent', manager: 'Manager', admin: 'Administrator', team_leader: 'Team Leader' };
    return roles[role] || role;
  };

  return (
    <ResponsiveLayout title="Profil" showLogout>
      <div className="max-w-lg mx-auto lg:mx-0">
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden animate-fadeIn">
          {/* Profile Header */}
          <div className="bg-[#1B3F8F] p-6 text-center">
            <div className="w-20 h-20 rounded-full bg-white/20 mx-auto flex items-center justify-center mb-3">
              <User size={40} className="text-white" />
            </div>
            <h2 className="text-xl font-semibold text-white tracking-tight">{user?.name}</h2>
            <p className="text-blue-200 text-sm mt-1">{user?.email}</p>
          </div>
          
          {/* Profile Details */}
          <div className="p-4 space-y-4">
            <div className="flex justify-between items-center py-3 border-b border-gray-100">
              <span className="text-sm text-gray-500">Uloga</span>
              <span className="text-sm font-medium text-gray-900 capitalize">
                {getRoleLabel(user?.role)}
              </span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-gray-100">
              <span className="text-sm text-gray-500">Email</span>
              <span className="text-sm font-medium text-gray-900">{user?.email}</span>
            </div>
            <div className="flex justify-between items-center py-3">
              <span className="text-sm text-gray-500">Tenant ID</span>
              <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">{user?.tenant_id}</span>
            </div>
          </div>
        </div>
      </div>
    </ResponsiveLayout>
  );
};

export default ProfilePage;
